import { Sport } from "@sportactics/board-editing";
import { Team } from "@sportactics/player-management";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useCustomPlayersLocalPersistence } from "./custom-players-local-persistence";
import { useSelectedSport } from "./use-selected-sport";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useTeamsLocalSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getTeamsLocalSWRKey(sport: Sport): TeamsLocalSWRKey {
  return getSWRKey(SwrStore.LocalCustomPlayerTeams, sport);
}

export type TeamsLocalSWRKey = readonly [SwrStore, Sport];

// Null while signed in: Firestore is the store that counts then, and a null key
// reads nothing.
function useKey(): TeamsLocalSWRKey | null {
  const sport = useSelectedSport();

  if (sport === undefined) return null;
  return getTeamsLocalSWRKey(sport);
}

function useFetcher(): (key: TeamsLocalSWRKey) => Promise<Team[]> {
  const { getTeamsWithSport } = useCustomPlayersLocalPersistence();

  return ([, sport]) => getTeamsWithSport(sport);
}
